import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { EditIcon } from "../../../ui/icons/edit"
import { formatterDate, optionsFormatter, statoRichiestaComplianceRequest } from "../../../utils"
import { GetAllComplianceRequests, resetGetAllStatus } from "./slice"

export function AllRequests() {
    const dispatch = useAppDispatch()
    const complianceRequestState = useAppSelector(state => state.complianceRequest)

    useEffect(() => {
        dispatch(GetAllComplianceRequests({ itemsPerPage: 0, page: 0, order: true }))
    }, [])

    useEffect(() => {
        if (complianceRequestState.getAllComplianceRequestsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [complianceRequestState.getAllComplianceRequestsStatus])

    if (complianceRequestState.getAllComplianceRequestsStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    const requests = complianceRequestState.allComplianceRequestsResponse?.data ?? []

    return (
        <div className="px-4 pb-4">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table id="users-table" className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Cliente</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Richiesta</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Mittente</th>
                            <th className="px-3 py-3 text-left font-semibold">Cliente Altro OdC</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Entrata</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Stato</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzionario</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[64px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {requests.length === 0 ? (
                            <tr>
                                <td colSpan={9} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                    Nessun cliente trovato
                                </td>
                            </tr>
                        ) : (
                            requests.map((request, index) =>
                                <tr
                                    key={request.id ?? index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-medium">{request.customerDataCompanyName || <span className="text-neutral-400">-</span>}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{formatterDate(request.date)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-medium">{request.sender || <span className="text-neutral-400">-</span>}</td>
                                    <td className="px-3 py-2 text-neutral-700 min-w-[240px]">
                                        {
                                            request.otherOdcCustomer?.length
                                                ? request.otherOdcCustomer.map((customerOtherOdc) => (
                                                    <p
                                                        key={`${request.id}-${customerOtherOdc.clientCode}-${customerOtherOdc.cuaa}`}
                                                        className="text-xs leading-5"
                                                    >
                                                        {customerOtherOdc.companyName} - {customerOtherOdc.cuaa} - {customerOtherOdc.clientCode}
                                                    </p>
                                                ))
                                                : <span className="text-neutral-400">-</span>
                                        }
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{request.requestProtocolInfo || <span className="text-neutral-400">-</span>}</td>
                                    <td className="px-3 py-2 text-neutral-700 min-w-[140px]">
                                        {
                                            request.complianceRequestStates?.length
                                                ? request.complianceRequestStates.map((state, stateIndex) => (
                                                    <p key={`${request.id}-${state.state}-${stateIndex}`} className="text-xs leading-5">
                                                        {optionsFormatter(state.state, statoRichiestaComplianceRequest)}
                                                    </p>
                                                ))
                                                : <span className="text-neutral-400">-</span>
                                        }
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{request.officerInfo || <span className="text-neutral-400">-</span>}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{formatterDate(request.date)}</td>
                                    <td className="px-3 py-2">
                                        <div className="flex items-center justify-center gap-2">
                                            <button
                                                className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                onClick={() => console.log()}
                                            >
                                                <EditIcon color="orange" size={20} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}